"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Select = require("../form/Select");

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderTypeSelect = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderTypeSelect, _Component);

  function VoucherOrderTypeSelect() {
    (0, _classCallCheck3.default)(this, VoucherOrderTypeSelect);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherOrderTypeSelect.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderTypeSelect)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherOrderTypeSelect, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-type-select" },
        _react2.default.createElement(_Select2.default, {
          disableLabel: true,
          placeholder: "Valitse lipuke",
          options: [{ id: "reception", name: "Vastaanottolipuke" }, { id: "pickup", name: "Noutolipuke" }],
          fieldProps: this.props.fieldProps
        })
      );
    }
  }]);
  return VoucherOrderTypeSelect;
}(_react.Component), _class.propTypes = {
  fieldProps: _react.PropTypes.object.isRequired
}, _temp);
exports.default = VoucherOrderTypeSelect;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderTypeSelect.js
 ** module id = 1202
 ** module chunks = 0
 **/